<template>
  <ria-select
    id="locale-selector"
    :selected="language"
    :options="languages.map(language => ({name: language, value: language}))"
    @change="(language) => changeLanguage(language)"
  />
</template>

<script>
import meta from "@/meta";
import { mapGetters } from 'vuex';

export default {
  name: "locale-select",
  data() {
    return {
      languages: meta.languages
    };
  },
  computed: {
    ...mapGetters('device', ['language']),
  },
  methods: {
    changeLanguage(language) {
      this.$router.push({ name: this.$route.name, params: { language }})
    }
  }
};
</script>

<style scoped></style>
